import React from 'react';
import styled from 'styled-components';
import Tooltip from '@mui/material/Tooltip';

export default function ProgressBar({ value, color, width = '50px' }) {
  return (
    <ProgressContainer {...{ width }}>
      <ProgressMarker {...{ value, color }}/>
      <ProgressText {...{ value, color }}>
        {Math.round(value)}%
      </ProgressText>
    </ProgressContainer>
  );
}

const ProgressContainer = styled.div`
  position: relative;
  width: ${({ width }) => width};
  height: 24px;
  display: flex;
  align-items: center;
`;

const ProgressMarker = styled.div`
  background-color:${({ color }) => color};
  width:${({ value }) => value}%;
  height: 4px;
  opacity: .75;
`;

const ProgressText = styled.div`
  position: absolute;
  background-color: ${({ color }) => color};
  color: white;
  left: ${({ value }) => value}%;
  top: 50%;
  transform: translateY(-50%);
  filter: drop-shadow(0 0 1px #888);
  padding: 2px;
  font-size: 12px;
  line-height: 12px;
  margin: auto 0;
`;
